import React from 'react';
import { Link } from 'react-router-dom';
import Flex from 'components/common/Flex';
import LoginForm from 'components/authentication/LoginForm';

const Login = () => (
  <>
<div className='text-center'>
      <h5 className='pb-2'>Log into Your Account</h5>
    <LoginForm />
    </div>
  </>
);

export default Login;
